import styled from "styled-components";
import { ITickerDisplayMobile } from "../TickerDisplayMobile";
import { getLinkColor } from "../../../../../ui/_themes/helpers";

export const Wrapper: any = styled.div<ITickerDisplayMobile>`
  width: 100%;
  overflow: hidden;
  user-select: none;
  cursor: default;
  display: flex;
  justify-content: ${(props: ITickerDisplayMobile) =>
    props.animationStopped ? "center" : "initial"};
  align-items: center;
  font-family: ArialMT, arial, sans-serif;
  letter-spacing: 0.02em;

  a {
    color: ${getLinkColor("tickerDisplay")};
    text-decoration: none;
  }

  line-height: 1em;
`;
